const EXACT_TRIAL_BOUNDARY_BYPASSES = new Set([
  '/mcp-auth-callback',
  '/auth/sso-callback',
  '/crm/failed',
]);

/** Only provider handoffs that must finish without organization UI may bypass
 * the mandatory trial decision. Signed-in auth, onboarding, feedback, mobile,
 * and feature routes remain behind the root boundary.
 *
 * The AppSumo match is on a whole path segment, not a bare prefix: a plain
 * `startsWith('/appsumo/activate')` also matches `/appsumo/activate-anything`,
 * which would hand any future sibling route a bypass of the mandatory trial
 * decision for free. */
export const shouldBypassTrialBoundary = (pathname: string) =>
  EXACT_TRIAL_BOUNDARY_BYPASSES.has(pathname) ||
  pathname === '/appsumo/activate' ||
  pathname.startsWith('/appsumo/activate/');
